var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoutcomponent = function SvgLogoutcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.167 8.5h11.666c.917 0 1.667.75 1.667 1.667v11.666c0 .917-.75 1.667-1.667 1.667H10.167c-.925 0-1.667-.75-1.667-1.667V18.5h1.667v3.333h11.666V10.167H10.167V13.5H8.5v-3.333c0-.917.742-1.667 1.667-1.667Zm5.416 11.667-1.175-1.175 2.15-2.159H8.5v-1.666h8.058l-2.15-2.159 1.175-1.175L19.75 16l-4.167 4.167Z",
    fill: "current"
  })));
};
export default SvgLogoutcomponent;